import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ApiConnectionString } from "../../constants/ApiConntection";
import { useAuthContext } from "../../hooks/useAuthContext";
import LoadingSpinner from "../../components/LoadingSpinner";
import { ArrowLeftCircle, ArrowRightCircle } from "react-bootstrap-icons";

export default function Earnings({ id }) {
  const { user,dispatch } = useAuthContext();
  const [today, setToday] = useState(new Date());
  const [isLoading,setIsLoading] = useState(true)
  let month = today.toLocaleString("default", { month: "long" });
  let year = today.getFullYear();

  const navi = useNavigate();
  let ConvertToCurrency = new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
  });
  const [payments, setPayments] = useState([]);
  const addMonth = () => {
    if(!isFutureDate()){
      const newDate = new Date(today);
      newDate.setMonth(newDate.getMonth() + 1);
      setToday(newDate);
    }
 
  };

  const isFutureDate = () => {
    const newDate = new Date(today);
    newDate.setMonth(newDate.getMonth() + 1);
    return newDate > new Date();
  };

  const subtractMonth = () => {
    const newDate = new Date(today);
    newDate.setMonth(newDate.getMonth() - 1);
    setToday(newDate);
  };

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const currentDate = today;
      setToday(currentDate);
  
      const firstDay = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        1
      );
      const firstDayOfMonth = firstDay.toISOString();
  
      const lastDay = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() + 1,
        0
      );
      const lastDayOfMonth = lastDay.toISOString();
  
      // Fetch payments for the current month
      const paymentResponse = await axios.get(
        `${ApiConnectionString}/api/Payments?ClubId=${id}&FromDate=${firstDayOfMonth}&ToDate=${lastDayOfMonth}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
  
      setPayments(paymentResponse.data);
  
    } catch (error) {
      if (error.status == 401) {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }
      // Handle errors here
      console.error("Error fetching payments:", error);
      // Optionally, you could set an error state or notify the user
    } finally {
      // Always set loading to false after fetching data
      setIsLoading(false);
    }
  };
  

  useEffect(() => {
    let timeout;

    if (user) {
      fetchData();
    } else {
      timeout = setTimeout(() => {
        dispatch({ type: "LOGOUT" });
        navi("/");
        // Add your fallback logic here
      }, 3000); // Delay of 3 seconds before executing the else logic
    }

    return () => clearTimeout(timeout); // Cleanup timeout on re-run
  }, [today,id,user]);

  if(isLoading){
    return(
      <div>
        <LoadingSpinner />
      </div>
    )
  }else{

  

  return (
    <div className="col">
    <div className="lightBlueBanner">
          <p className="fw-bold p-2">Earnings</p>
        </div>

        <div className="text-center">
        <p className="fw-bold red-text">
        {month} {year}
      </p>  </div>
      
      <div className="d-flex justify-content-between">
          <ArrowLeftCircle
            size={50}
            onClick={subtractMonth}
          />
          <ArrowRightCircle
            size={50}
            onClick={addMonth}
            className={`${
              isFutureDate()  ? "opacity-50" : "pointer"
            }`}
            
          />
        </div>
      
 
      {payments.length > 0 ? (
        <table className="custom-table">
          <thead className="blueBanner">
            <tr>
              <th>User</th>
              <th>Package</th>
              <th>Amount</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {payments.map((pay) => (
              <tr key={pay.id} >
                <td>{pay.username}</td>
                <td>{pay.name}</td>
                <td>{ConvertToCurrency.format(pay.amount / 100)}</td>
                {pay.created && <td>{pay.created.substring(0, 10)}</td>}
                {/* Add more table cells based on the data */}
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>No payments made</p>
      )}
    </div>
  );
}
}